import { AsideCallOut } from '../../models/app-data-model';
import AsideCalloutData from '../aside-callout-data/AsideCalloutData';
import './AsideCallouts.scss';

import React from 'react';

export type AsideCalloutsProps = {
  asideCallouts: AsideCallOut[];
};

const AsideCallouts: React.FC<AsideCalloutsProps> = (props: AsideCalloutsProps) => {
  const calloutData = props.asideCallouts.map((callout, index) => <AsideCalloutData asideCallout={callout} key={index} />)
  return <div className='aside-callout'>
    {calloutData}
  </div>;
};

export default AsideCallouts;
